import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  styleUrl: './app.css',
  templateUrl: './app.html',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- Angular requires a decorated component class.
export class App {}
